export interface IHLP_FORMULA {
  outstandingAmount: number;
  months: number;
  rate: number;
  paid: number;
}

export const HLP_FORMULA = ({
  outstandingAmount,
  months,
  rate,
  paid,
}: IHLP_FORMULA) => {
  const amo = Number(outstandingAmount);
  const mon = Number(months);
  const r = Number(rate) / (12 * 100);
  const p = Number(paid);

  if (amo < 0 || amo > 1e10 || p < 0 || p > 1e10 || p >= amo) {
    const emptyRes = 0;
    return {
      emi: emptyRes.toFixed(0),
    };
  }
  const rem = Number(amo - p);
  const res = Math.round(
    (rem * r * Math.pow(1 + r, mon)) / (Math.pow(1 + r, mon) - 1)
  );
  return {
    emi: res.toFixed(0),
  };
};
